import React from "react";
import { Alert } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";

export type SntInfoPanelVariant = "default" | "heavy";

// Base look per variant. "default" is the new, softer look applied everywhere;
// "heavy" preserves the original stronger contrast for callers that opt in.
const VARIANT_STYLES: Record<SntInfoPanelVariant, React.CSSProperties> = {
  default: {
    backgroundColor: "#eff3f4", // $Sensolus_BG_LightBlue — one step darker than zebra so it doesn't blend with white
    border: "none",
    color: "#304269", // crisp dark text, only the background is softened
    fontSize: "13px", // one step under the 14px base so the panel reads lighter
  },
  heavy: {
    backgroundColor: "#eff3f4", // $Sensolus_BG_LightBlue
    border: "none",
    color: "#304269",
  },
};

interface SntInfoPanelProps {
  className?: string;
  children?: React.ReactNode;
  maxWidth?: number;
  customStyle?: React.CSSProperties;
  variant?: SntInfoPanelVariant;
}

const SntInfoPanel: React.FC<SntInfoPanelProps> = ({
  className,
  children,
  maxWidth = 900,
  customStyle,
  variant = "default",
}) => {
  return (
    <Alert
      className={className}
      variant="sensolus-grey"
      style={{
        ...VARIANT_STYLES[variant],
        ...customStyle,
      }}
    >
      <div className="d-flex">
        <div style={{ width: 24 }}>
          <IcomoonIcon className="me-2" icon="info" size={16} />
        </div>
        {/* text longer than 900px is bad for reading. */}
        <div style={{ maxWidth: maxWidth > 0 ? maxWidth : undefined }}>
          {children}
        </div>
      </div>
    </Alert>
  );
};

export default SntInfoPanel;
